/**
 * 模块名称: 设置行业
 * @author zhuyan@372163.com
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Table,
  Form,
  Button,
  Input,
  Drawer,
  Icon,
  Popconfirm,
  message,
  Modal,
} from 'antd'
// import BtnGroup from '@/components/BtnGroup'
import Subsectors from './Subsectors'

const { Column } = Table
const EditableContext = React.createContext()

const SetIndustry = (props) => {
  const { setIndustryVisible, getList, sysProjectId } = props
  const [industryList, setIndustryList] = useState([])
  const [loading, setLoading] = useState(false)
  const [cateEditVal, setCateEditVal] = useState('')
  const [editingCateKey, setEditingCateKey] = useState('')
  const [addCateVisible, setAddCateVisible] = useState(false)
  const [newCateName, setNewCateName] = useState('')
  const [subVisible, setSubVisible] = useState(false) // 二级行业
  const [pId, setPid] = useState('')
  const [projectIdTwo, setProjectIdTwo] = useState('')
  const [oneName, setOneName] = useState('')

  useEffect(() => {
    getIndustryList()
  }, [])

  const getIndustryList = () => {
    setLoading(true)
    api.getSysProjectIndustryList({
      sysProjectId: sysProjectId,
      projectIndustryPid: 0
    }).then(data => {
      setIndustryList(data)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const isCateEditing = record => {
    return record.id === editingCateKey
  }

  // 编辑行业
  const editCateSave = (id) => {
    if (cateEditVal == '') {
      message.warning('行业不能为空')
      return
    }
    if (cateEditVal.indexOf(" ") >= 0) {
      message.warning('行业内不得输入空格')
      return
    }
    api.saveSysProjectIndustry({
      id: id,
      name: cateEditVal,
      sysProjectId: sysProjectId
    }).then(res => {
      message.success('保存成功')
      setEditingCateKey('')
      getIndustryList()
    })
  }

  const editCateCancel = (id) => {
    setEditingCateKey('')
  }

  const editCate = (record) => {
    setCateEditVal(record.name)
    setEditingCateKey(record.id)
  }

  const onChangeCateVal = (e) => {
    e.persist()
    setCateEditVal(e.target.value)
  }

  // 删除标签
  const onDeleteCate = (id) => {
    api.updateSysProjectIndustryIsDel({ id, isDel: 1 }, true).then(() => {
      message.success('删除成功')
      getIndustryList()
    })
  }

  const getAddCateName = e => {
    setNewCateName(e.target.value)
  }

  // 添加以及行业
  const addCateType = () => {
    setNewCateName('')
    setAddCateVisible(true)
  }

  // 添加行业
  const onAddCateOperation = () => {
    if (!newCateName.length) {
      message.warning('行业不能为空')
      return
    }
    if (newCateName.indexOf(" ") >= 0) {
      message.warning('行业内不得输入空格')
      return
    }
    api.saveSysProjectIndustry({
      id: '',
      pid: 0,
      name: newCateName,
      sysProjectId: sysProjectId
    }).then(res => {
      message.success('添加行业成功')
      setEditingCateKey('')
      getIndustryList()
      setAddCateVisible(false)
    })
  }

  const onIndusClose = () => {
    setIndustryVisible(false)
    getList()
  }

  // 二级行业
  const onsub = (val) => {
    setPid(val.id)
    setProjectIdTwo(val.sysProjectId)
    setOneName(val.name)
    setSubVisible(true)
  }

  return (
    <>
      <div className="setIndustry">
        <EditableContext.Provider>
          <Table
            dataSource={industryList}
            rowKey="id"
            loading={loading}
            pagination={false}
          >
            <Column title="序号" dataIndex="id" width={'15%'} />
            <Column title="一级行业"
              render={(text, record) =>
                <>
                  {isCateEditing(record) ? <div><Input onPressEnter={() => editCateSave(record.id)} defaultValue={text.name} onChange={onChangeCateVal} /></div> : <div style={{ lineHeight: '32px' }}>{text.name}</div>}
                </>
              }
            />
            <Column title="二级行业数量" dataIndex="childIndustryNum" />
            <Column title="操作"
              render={(text, record) => {
                const editable = isCateEditing(record)
                return editable ? (
                  <span>
                    <Popconfirm title="确定要取消编辑吗？" onConfirm={() => editCateCancel(record.id)}>
                      <Icon className="operate-icon" type="close" style={{ color: '#F35D58' }} />
                    </Popconfirm>
                    <EditableContext.Consumer>
                      {() => (
                        <a
                          onClick={() => editCateSave(record.id)}
                          style={{ marginRight: 8 }}
                        >
                          <Icon className="operate-icon" type="check" style={{ color: '#3A9F33' }} />
                        </a>
                      )}
                    </EditableContext.Consumer>
                  </span>
                ) : (
                    <>
                      <a disabled={editingCateKey !== ''} onClick={() => editCate(record)}>
                        <Icon className="operate-icon" type="edit" />
                      </a>
                      <a disabled={editingCateKey !== ''}>
                        <Popconfirm title="确定要删除该类别吗？" onConfirm={() => onDeleteCate(record.id)}>
                          {
                            editingCateKey !== '' ?
                              <Icon className="operate-icon" type="delete" style={{ color: '#c8c8c8' }} />
                              :
                              <Icon className="operate-icon" type="delete" style={{ color: '#F35D58' }} />
                          }
                        </Popconfirm>
                      </a>
                      <a style={{ color: '#008CFA', marginLeft: 12 }} onClick={() => onsub(record)}>二级行业</a>
                    </>
                  )
              }}
            />
          </Table>
          <div className="type-add" onClick={addCateType}><span>+添加</span></div>
          <Modal
            title="添加一级行业"
            visible={addCateVisible}
            onOk={onAddCateOperation}
            onCancel={() => { setAddCateVisible(false) }}
            destroyOnClose={true}
          >
            <Input placeholder="请输入要添加的一级行业名称" onChange={getAddCateName} />
          </Modal>
          <Drawer
            title={`二级行业-${oneName}`}
            width={640}
            onClose={()=>setSubVisible(false)}
            visible={subVisible}
            destroyOnClose={true}
          >
            <Subsectors
              setSubVisible={setSubVisible}
              getList={getIndustryList}
              pId={pId}
              projectIdTwo={projectIdTwo}
            />
          </Drawer>
        </EditableContext.Provider>
        <div style={{height:60}}></div>
        <div className="setCloseBtn">
          {/* <BtnGroup cancelName="关闭" confirmName="确定" onConfirm={onIndusClose} onCancel={onIndusClose} /> */}
         <Button type="primary" onClick={onIndusClose}>关闭</Button>
        </div>
      </div>
    </>
  )
}

export default Form.create()(SetIndustry)